<template>
  <page>
    <div>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
          <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <form ref="TXTForm">
                  <input type="file" style="display: none" ref="TXTfile" accept=".txt" @change="doValidateFile" />
                </form>
                <v-text-field
                  readonly
                  v-model="form.requestedFile"
                  :label="labels.requestedFile"
                  :error-messages="errors.collect('requestedFile')"
                  data-vv-name="requestedFile"
                  :data-vv-as="labels.requestedFile"
                  append-icon="mdi-magnify"
                  @click:append="pickFile"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-checkbox
                  v-model="form.checkFlag"
                  :label="labels.checkFlag"
                  :error-messages="errors.collect('checkFlag')"
                  data-vv-name="checkFlag"
                  :data-vv-as="labels.checkFlag"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :label="labels.appendixType"
                  :items="appendixTypeList"
                  v-model="form.appendixType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="appendixType"
                  :data-vv-as="labels.appendixType"
                  :error-messages="errors.collect('appendixType')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
        </v-flex>
      </v-layout>
          </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        <v-spacer class="mt-3"></v-spacer>
        <v-flex xs12 sm12 md12 lg12>
          <v-btn class="mr-3" color="primary"  dark :loading="processing" @click.prevent="doSend">
            <v-icon dark left>mdi-upload</v-icon>
            Upload
          </v-btn>
        </v-flex>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      uploading: false,
      labels: {
        requestedFile: 'LTA Vehicle Insurance Details Request File',
        checkFlag: "Set 'Check' flag to 'Yes' for all record",
        appendixType: 'Appendix Type'
      },
      form: {
        requestedFile: '',
        checkFlag: false,
        appendixType: ''
      },
      textDataTransferObject: [],
      appendixTypeList: [
        { code: 'C', value: 'Appendix C' },
        { code: 'F', value: 'Appendix F' }
      ],
      panel: [0]
    }
  },
  methods: {
    doValidateFile(e) {
      this.form.requestedFile = ''
      this.textDataTransferObject = []
      this.resetMessages()
      if (e.target.files[0]) {
        this.uploading = true
        const file = e.target.files[0]
        if (file.name.indexOf('.txt') !== -1) {
          this.form.requestedFile = file.name
          const fileReader = new FileReader()
          fileReader.readAsText(file)
          fileReader.onload = async () => {
            var lines = fileReader.result.split('\n')
            let countCaseC = 0
            let countCaseT = 0
            let detailLine = []
            let controlRecord = []
            let trailerRecord = []
            if (lines.length < 1) {
              this.$toast.error('No Line Is Found On The Text File Uploaded')
            } else {
              for (var line = 0; line < lines.length; line++) {
                if (lines[line].length > 191) {
                  // If needs to be strict on the line length. can be removed
                  // this.$toast.error('More than 190 characters in Line:' + (line + 1) + ', Please check your text file')
                }
                // If User Uploaded a file with multiple control/trailer record
                if (countCaseC > 1) {
                  this.$toast.error('Multiple Control Record found!')
                  this.form.requestedFile = ''
                  this.textDataTransferObject = []
                  break
                }
                if (countCaseT > 1) {
                  this.$toast.error('Multiple Trailer Record found!')
                  this.form.requestedFile = ''
                  this.textDataTransferObject = []
                  break
                }
                switch (lines[line].substring(0, 1)) {
                  // As the JSON Object can held at maximum 100 characters in one element
                  // Split the element into 2 line, max 190 characters each line
                  case 'C':
                    controlRecord.push({
                      cTextLine: lines[line].substring(0, 100),
                      cTextLine2: lines[line].substring(100, 200)
                    })
                    countCaseC++
                    break
                  case 'T':
                    trailerRecord.push({
                      cTextLine: lines[line].substring(0, 100),
                      cTextLine2: lines[line].substring(100, 200)
                    })
                    countCaseT++
                    break
                  case 'D':
                    detailLine.push({
                      cTextLine: lines[line].substring(0, 100),
                      cTextLine2: lines[line].substring(100, 200)
                    })
                    break
                  default:
                    break
                }
              }
              this.textDataTransferObject.push({
                detailLine: detailLine,
                controlRecord: controlRecord,
                trailerRecord: trailerRecord
              })
            }
          }
        } else {
          this.$toast.error('Please Select Text File (.txt) Only!')
        }
      }
      this.uploading = false
      this.doUpload(e)
    },
    pickFile() {
      this.$refs.TXTForm.reset()
      this.$refs.TXTfile.click()
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    async doUpload(event) {
      await this.getFile(event)
    },
    async doSend() {
      const dto = []
      dto.push({
        checkFlag: this.form.checkFlag,
        appendixType: this.form.appendixType,
        requestedFileName: this.form.requestedFile,
        dataUploaded: this.textDataTransferObject,
        format: 'PDF',
        sendEmail: false
      })
      const apiURI = this.$store.state.underwriting.dataTransferSettings.menu.uploadVehDetReqAppendixCF
      if (apiURI) {
        this.uploading = true
        try {
          await this.$http.post(apiURI, dto[0])
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.uploading = false
      } else {
        this.$toast.error('Request Mapping Not Found!')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit')
    }
  },
  mixins: [MessageMixin]
}
</script>
